import { Validator } from '@vista-digital/validator';
import { cdnStandardAssetOptionsValidator } from '../../../../validators/cdn-asset-options';
export const defaultEventImageCdnOptions = {
    eventImage: { width: 200 }
};
export const eventImageCdnOptionsValidatorSchema = {
    eventImage: cdnStandardAssetOptionsValidator
};
export const eventImageCdnOptionsValidator = Validator.object(eventImageCdnOptionsValidatorSchema);
